module.exports = __webpack_public_path__ + "static/media/icono_correo.c0200f80.svg";